<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="d-flex min-vh-100 bg-cover" :style="'background-position: bottom;background-image: url('+require('@/assets/img/404.jpg')+');'">
            <div class="position-absolute w-100 min-vh-100 inset-0" style="z-index:1;backdrop-filter: blur(4px); background-color: rgba(0, 0, 0, .4);"></div>
            <div class="content container position-relative text-center h-100 d-flex flex-row align-items-center justify-content-center" style="z-index: 2;">
                <div>
                    <h1 class="text-white display-2"><b>404</b></h1>
                    <h2 class="text-white mb-4">Hors-jeu ! Cette page est introuvable.</h2>
                    <a href="/" class="btn btn-primary">Accueil</a>
                </div>
            </div>            
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style>
</style>
<script>
export default {}
</script>